import { render, staticRenderFns } from "./LeadsView.vue?vue&type=template&id=5cd58026&scoped=true"
import script from "./LeadsView.vue?vue&type=script&lang=js"
export * from "./LeadsView.vue?vue&type=script&lang=js"
import style0 from "./LeadsView.vue?vue&type=style&index=0&id=5cd58026&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd58026",
  null
  
)

export default component.exports